module.exports = __webpack_public_path__ + "img/icon_re_bottom.dafc61f4.png";